/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BREEDER v2 API
 * OpenAPI spec version: 2.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BreederGenealogyApplicationGeneSearchOptions,
  Carriers,
  GeneSearchTraitRowsParams,
  HTTPValidationError,
  Molecular,
  Offspring,
  ParentsFound,
  Places,
  SearchIn,
  TraitIn,
  TraitTable,
  TraitView
} from '../model';

import { apiFetch } from '../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGeneSearchCarriersUrl = () => {




  return `/api/v1/gene-search/carriers`
}

/**
 * @summary The lines that satisfy the terms, or a list's every line (unknown results flagged)
 */
export const geneSearchCarriers = async (searchIn: SearchIn, options?: Parameters<typeof apiFetch>[1]): Promise<Carriers> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<Carriers>(getGeneSearchCarriersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(searchIn)
  }
);}





export const getGeneSearchCarriersMutationKey = () => ['geneSearchCarriers'] as const;

export const getGeneSearchCarriersMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geneSearchCarriers>>, TError,GeneSearchCarriersMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof geneSearchCarriers>>, TError,GeneSearchCarriersMutationVariables, TContext> => {

const mutationKey = getGeneSearchCarriersMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof geneSearchCarriers>>, GeneSearchCarriersMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  geneSearchCarriers(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GeneSearchCarriersMutationResult = NonNullable<Awaited<ReturnType<typeof geneSearchCarriers>>>
    export type GeneSearchCarriersMutationBody = SearchIn
    export type GeneSearchCarriersMutationError = HTTPValidationError
    export type GeneSearchCarriersMutationVariables = {data: SearchIn}

    /**
 * @summary The lines that satisfy the terms, or a list's every line (unknown results flagged)
 */
export const useGeneSearchCarriers = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geneSearchCarriers>>, TError,GeneSearchCarriersMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof geneSearchCarriers>>,
        TError,
        GeneSearchCarriersMutationVariables,
        TContext
      > => {
      return useMutation(getGeneSearchCarriersMutationOptions(options), queryClient);
    }
    export const getGeneSearchExportUrl = () => {




  return `/api/v1/gene-search/export`
}

/**
 * @summary The search's lines, offspring, parents, places and lab results as an .xlsx file
 */
export const geneSearchExport = async (searchIn: SearchIn, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<void>(getGeneSearchExportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(searchIn)
  }
);}





export const getGeneSearchExportMutationKey = () => ['geneSearchExport'] as const;

export const getGeneSearchExportMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geneSearchExport>>, TError,GeneSearchExportMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof geneSearchExport>>, TError,GeneSearchExportMutationVariables, TContext> => {

const mutationKey = getGeneSearchExportMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof geneSearchExport>>, GeneSearchExportMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  geneSearchExport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GeneSearchExportMutationResult = NonNullable<Awaited<ReturnType<typeof geneSearchExport>>>
    export type GeneSearchExportMutationBody = SearchIn
    export type GeneSearchExportMutationError = HTTPValidationError
    export type GeneSearchExportMutationVariables = {data: SearchIn}

    /**
 * @summary The search's lines, offspring, parents, places and lab results as an .xlsx file
 */
export const useGeneSearchExport = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geneSearchExport>>, TError,GeneSearchExportMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof geneSearchExport>>,
        TError,
        GeneSearchExportMutationVariables,
        TContext
      > => {
      return useMutation(getGeneSearchExportMutationOptions(options), queryClient);
    }
    export const getGeneSearchMolecularUrl = () => {




  return `/api/v1/gene-search/molecular`
}

/**
 * @summary The lines' lab results (of the terms, or every one without terms)
 */
export const geneSearchMolecular = async (searchIn: SearchIn, options?: Parameters<typeof apiFetch>[1]): Promise<Molecular> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<Molecular>(getGeneSearchMolecularUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(searchIn)
  }
);}





export const getGeneSearchMolecularMutationKey = () => ['geneSearchMolecular'] as const;

export const getGeneSearchMolecularMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geneSearchMolecular>>, TError,GeneSearchMolecularMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof geneSearchMolecular>>, TError,GeneSearchMolecularMutationVariables, TContext> => {

const mutationKey = getGeneSearchMolecularMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof geneSearchMolecular>>, GeneSearchMolecularMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  geneSearchMolecular(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GeneSearchMolecularMutationResult = NonNullable<Awaited<ReturnType<typeof geneSearchMolecular>>>
    export type GeneSearchMolecularMutationBody = SearchIn
    export type GeneSearchMolecularMutationError = HTTPValidationError
    export type GeneSearchMolecularMutationVariables = {data: SearchIn}

    /**
 * @summary The lines' lab results (of the terms, or every one without terms)
 */
export const useGeneSearchMolecular = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geneSearchMolecular>>, TError,GeneSearchMolecularMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof geneSearchMolecular>>,
        TError,
        GeneSearchMolecularMutationVariables,
        TContext
      > => {
      return useMutation(getGeneSearchMolecularMutationOptions(options), queryClient);
    }
    export const getGeneSearchOffspringUrl = () => {




  return `/api/v1/gene-search/offspring`
}

/**
 * @summary The lines crossed from the matching lines, with their own results and places
 */
export const geneSearchOffspring = async (searchIn: SearchIn, options?: Parameters<typeof apiFetch>[1]): Promise<Offspring> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<Offspring>(getGeneSearchOffspringUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(searchIn)
  }
);}





export const getGeneSearchOffspringMutationKey = () => ['geneSearchOffspring'] as const;

export const getGeneSearchOffspringMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geneSearchOffspring>>, TError,GeneSearchOffspringMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof geneSearchOffspring>>, TError,GeneSearchOffspringMutationVariables, TContext> => {

const mutationKey = getGeneSearchOffspringMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof geneSearchOffspring>>, GeneSearchOffspringMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  geneSearchOffspring(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GeneSearchOffspringMutationResult = NonNullable<Awaited<ReturnType<typeof geneSearchOffspring>>>
    export type GeneSearchOffspringMutationBody = SearchIn
    export type GeneSearchOffspringMutationError = HTTPValidationError
    export type GeneSearchOffspringMutationVariables = {data: SearchIn}

    /**
 * @summary The lines crossed from the matching lines, with their own results and places
 */
export const useGeneSearchOffspring = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geneSearchOffspring>>, TError,GeneSearchOffspringMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof geneSearchOffspring>>,
        TError,
        GeneSearchOffspringMutationVariables,
        TContext
      > => {
      return useMutation(getGeneSearchOffspringMutationOptions(options), queryClient);
    }
    export const getGeneSearchOptionsUrl = () => {




  return `/api/v1/gene-search/options`
}

/**
 * @summary The genes, loci, alleles and markers a search can ask for
 */
export const geneSearchOptions = async ( options?: Parameters<typeof apiFetch>[1]): Promise<BreederGenealogyApplicationGeneSearchOptions> => {

  return apiFetch<BreederGenealogyApplicationGeneSearchOptions>(getGeneSearchOptionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGeneSearchOptionsQueryKey = () => {
    return [
    `/api/v1/gene-search/options`
    ] as const;
    }


export const getGeneSearchOptionsQueryOptions = <TData = Awaited<ReturnType<typeof geneSearchOptions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof geneSearchOptions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGeneSearchOptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof geneSearchOptions>>> = ({ signal }) => geneSearchOptions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof geneSearchOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GeneSearchOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof geneSearchOptions>>>
export type GeneSearchOptionsQueryError = unknown


export function useGeneSearchOptions<TData = Awaited<ReturnType<typeof geneSearchOptions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof geneSearchOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof geneSearchOptions>>,
          TError,
          Awaited<ReturnType<typeof geneSearchOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGeneSearchOptions<TData = Awaited<ReturnType<typeof geneSearchOptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof geneSearchOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof geneSearchOptions>>,
          TError,
          Awaited<ReturnType<typeof geneSearchOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGeneSearchOptions<TData = Awaited<ReturnType<typeof geneSearchOptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof geneSearchOptions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The genes, loci, alleles and markers a search can ask for
 */

export function useGeneSearchOptions<TData = Awaited<ReturnType<typeof geneSearchOptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof geneSearchOptions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGeneSearchOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGeneSearchParentsUrl = () => {




  return `/api/v1/gene-search/parents`
}

/**
 * @summary The mother and father of each line, with their results
 */
export const geneSearchParents = async (searchIn: SearchIn, options?: Parameters<typeof apiFetch>[1]): Promise<ParentsFound> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<ParentsFound>(getGeneSearchParentsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(searchIn)
  }
);}





export const getGeneSearchParentsMutationKey = () => ['geneSearchParents'] as const;

export const getGeneSearchParentsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geneSearchParents>>, TError,GeneSearchParentsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof geneSearchParents>>, TError,GeneSearchParentsMutationVariables, TContext> => {

const mutationKey = getGeneSearchParentsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof geneSearchParents>>, GeneSearchParentsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  geneSearchParents(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GeneSearchParentsMutationResult = NonNullable<Awaited<ReturnType<typeof geneSearchParents>>>
    export type GeneSearchParentsMutationBody = SearchIn
    export type GeneSearchParentsMutationError = HTTPValidationError
    export type GeneSearchParentsMutationVariables = {data: SearchIn}

    /**
 * @summary The mother and father of each line, with their results
 */
export const useGeneSearchParents = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geneSearchParents>>, TError,GeneSearchParentsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof geneSearchParents>>,
        TError,
        GeneSearchParentsMutationVariables,
        TContext
      > => {
      return useMutation(getGeneSearchParentsMutationOptions(options), queryClient);
    }
    export const getGeneSearchPlacesUrl = () => {




  return `/api/v1/gene-search/places`
}

/**
 * @summary Where the matching lines stood in the field in the years, and their gene-bank accessions
 */
export const geneSearchPlaces = async (searchIn: SearchIn, options?: Parameters<typeof apiFetch>[1]): Promise<Places> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<Places>(getGeneSearchPlacesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(searchIn)
  }
);}





export const getGeneSearchPlacesMutationKey = () => ['geneSearchPlaces'] as const;

export const getGeneSearchPlacesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geneSearchPlaces>>, TError,GeneSearchPlacesMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof geneSearchPlaces>>, TError,GeneSearchPlacesMutationVariables, TContext> => {

const mutationKey = getGeneSearchPlacesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof geneSearchPlaces>>, GeneSearchPlacesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  geneSearchPlaces(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GeneSearchPlacesMutationResult = NonNullable<Awaited<ReturnType<typeof geneSearchPlaces>>>
    export type GeneSearchPlacesMutationBody = SearchIn
    export type GeneSearchPlacesMutationError = HTTPValidationError
    export type GeneSearchPlacesMutationVariables = {data: SearchIn}

    /**
 * @summary Where the matching lines stood in the field in the years, and their gene-bank accessions
 */
export const useGeneSearchPlaces = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geneSearchPlaces>>, TError,GeneSearchPlacesMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof geneSearchPlaces>>,
        TError,
        GeneSearchPlacesMutationVariables,
        TContext
      > => {
      return useMutation(getGeneSearchPlacesMutationOptions(options), queryClient);
    }
    export const getGeneSearchTraitUrl = () => {




  return `/api/v1/gene-search/trait`
}

/**
 * @summary A trait's plot values grouped by whether the line satisfies a term
 */
export const geneSearchTrait = async (traitIn: TraitIn, options?: Parameters<typeof apiFetch>[1]): Promise<TraitView> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<TraitView>(getGeneSearchTraitUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(traitIn)
  }
);}





export const getGeneSearchTraitMutationKey = () => ['geneSearchTrait'] as const;

export const getGeneSearchTraitMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geneSearchTrait>>, TError,GeneSearchTraitMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof geneSearchTrait>>, TError,GeneSearchTraitMutationVariables, TContext> => {

const mutationKey = getGeneSearchTraitMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof geneSearchTrait>>, GeneSearchTraitMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  geneSearchTrait(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GeneSearchTraitMutationResult = NonNullable<Awaited<ReturnType<typeof geneSearchTrait>>>
    export type GeneSearchTraitMutationBody = TraitIn
    export type GeneSearchTraitMutationError = HTTPValidationError
    export type GeneSearchTraitMutationVariables = {data: TraitIn}

    /**
 * @summary A trait's plot values grouped by whether the line satisfies a term
 */
export const useGeneSearchTrait = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geneSearchTrait>>, TError,GeneSearchTraitMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof geneSearchTrait>>,
        TError,
        GeneSearchTraitMutationVariables,
        TContext
      > => {
      return useMutation(getGeneSearchTraitMutationOptions(options), queryClient);
    }
    export const getGeneSearchTraitExportUrl = () => {




  return `/api/v1/gene-search/trait/export`
}

/**
 * @summary A trait's plot rows as an .xlsx file
 */
export const geneSearchTraitExport = async (traitIn: TraitIn, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<void>(getGeneSearchTraitExportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(traitIn)
  }
);}





export const getGeneSearchTraitExportMutationKey = () => ['geneSearchTraitExport'] as const;

export const getGeneSearchTraitExportMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geneSearchTraitExport>>, TError,GeneSearchTraitExportMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof geneSearchTraitExport>>, TError,GeneSearchTraitExportMutationVariables, TContext> => {

const mutationKey = getGeneSearchTraitExportMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof geneSearchTraitExport>>, GeneSearchTraitExportMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  geneSearchTraitExport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GeneSearchTraitExportMutationResult = NonNullable<Awaited<ReturnType<typeof geneSearchTraitExport>>>
    export type GeneSearchTraitExportMutationBody = TraitIn
    export type GeneSearchTraitExportMutationError = HTTPValidationError
    export type GeneSearchTraitExportMutationVariables = {data: TraitIn}

    /**
 * @summary A trait's plot rows as an .xlsx file
 */
export const useGeneSearchTraitExport = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geneSearchTraitExport>>, TError,GeneSearchTraitExportMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof geneSearchTraitExport>>,
        TError,
        GeneSearchTraitExportMutationVariables,
        TContext
      > => {
      return useMutation(getGeneSearchTraitExportMutationOptions(options), queryClient);
    }
    export const getGeneSearchTraitRowsUrl = (params?: GeneSearchTraitRowsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/gene-search/trait/rows?${stringifiedParams}` : `/api/v1/gene-search/trait/rows`
}

/**
 * @summary A trait's plots row by row with the fields, the terms' results and the group
 */
export const geneSearchTraitRows = async (traitIn: TraitIn,
    params?: GeneSearchTraitRowsParams, options?: Parameters<typeof apiFetch>[1]): Promise<TraitTable> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<TraitTable>(getGeneSearchTraitRowsUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(traitIn)
  }
);}





export const getGeneSearchTraitRowsMutationKey = () => ['geneSearchTraitRows'] as const;

export const getGeneSearchTraitRowsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geneSearchTraitRows>>, TError,GeneSearchTraitRowsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof geneSearchTraitRows>>, TError,GeneSearchTraitRowsMutationVariables, TContext> => {

const mutationKey = getGeneSearchTraitRowsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof geneSearchTraitRows>>, GeneSearchTraitRowsMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  geneSearchTraitRows(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GeneSearchTraitRowsMutationResult = NonNullable<Awaited<ReturnType<typeof geneSearchTraitRows>>>
    export type GeneSearchTraitRowsMutationBody = TraitIn
    export type GeneSearchTraitRowsMutationError = HTTPValidationError
    export type GeneSearchTraitRowsMutationVariables = {data: TraitIn;params?: GeneSearchTraitRowsParams}

    /**
 * @summary A trait's plots row by row with the fields, the terms' results and the group
 */
export const useGeneSearchTraitRows = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geneSearchTraitRows>>, TError,GeneSearchTraitRowsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof geneSearchTraitRows>>,
        TError,
        GeneSearchTraitRowsMutationVariables,
        TContext
      > => {
      return useMutation(getGeneSearchTraitRowsMutationOptions(options), queryClient);
    }
